import { LocalStorageContext, LocalStorageContextRecord, LocalStorageStore } from 'lib/context/app'
import { FC, ReactNode, useMemo, useState } from 'react'

export const LocalStorageContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [store, setStore] = useState<LocalStorageStore>({})

    const value = useMemo(() => new LocalStorageContextRecord({ store, setStore }), [store, setStore])

    return <LocalStorageContext.Provider value={value}>
        {children}
    </LocalStorageContext.Provider>
}
